<template>
  <div>
    <vs-prompt
      :active.sync="showPlanDialog"
      class="user-plan-prompt"
      buttons-hidden
      title=""
      :color="AISEA_COLOR.BLACK"
    >
      <div class="w-full user-plan-dialog-area" style="position: relative">
        <div style="position: absolute; top: 0px; right: 0px">
          <feather-icon
            class="p-2 rounded cursor-pointer"
            icon="XIcon"
            svg-classes="h-5 w-5"
            @click="showPlanDialog = false"
          />
        </div>
        <div class="dialog-header grid justify-items-center">
          <div class="dialog-title">AiseaCrew労務管理 契約プラン</div>
          <div>本画面から、Aisea Crewのプラン申し込みが可能です。</div>
          <div>プラン内容を確認し、「利用開始」をクリックしてください。</div>
        </div>
        <vs-row style="max-height: calc(100vh - 160px); overflow-y: auto">
          <vs-col vs-type="flex" vs-lg="6" vs-xs="12">
            <vx-card class="plan-view free-plan">
              <div class="plan-title">トライアル</div>
              <vs-divider :color="AISEA_COLOR.SLIGHTLY_GRAY"></vs-divider>
              <div class="price-area flex justify-center items-center">
                <div>
                  <span class="price-text" style="font-size: 28px">無料</span>
                </div>
              </div>
              <div class="plan-explain-alea">
                <vs-divider :color="AISEA_COLOR.SLIGHTLY_GRAY"></vs-divider>
                <div class="flex justify-between px-2 items-center">
                  <span class="title">機能</span>
                  <span class="value">無制限</span>
                </div>
                <vs-divider :color="AISEA_COLOR.SLIGHTLY_GRAY"></vs-divider>
                <div class="flex justify-between px-2 items-center">
                  <span class="title">船舶数</span>
                  <span class="value">無制限</span>
                </div>
                <vs-divider :color="AISEA_COLOR.SLIGHTLY_GRAY"></vs-divider>
                <div class="flex justify-between px-2 items-center">
                  <span class="title">船員・陸上管理者数</span>
                  <span class="value">無制限</span>
                </div>
                <vs-divider :color="AISEA_COLOR.SLIGHTLY_GRAY"></vs-divider>
                <div class="flex justify-between px-2 items-center">
                  <span class="title">利用可能期間</span>
                  <span class="value">
                    <span style="font-size: 18px">２</span>
                    <span style="font-size: 14px">ヶ月</span>
                  </span>
                </div>
                <vs-divider :color="AISEA_COLOR.SLIGHTLY_GRAY"></vs-divider>
                <div class="mb-4 h-24">
                  <span class="plan-explain-text"
                    >無料で2か月間お試しできます。終了後はログインできなくなりますので、ベーシックプランをご契約下さい。</span
                  >
                </div>

                <div class="update-plan-button selected-plan">現在ご利用中</div>
              </div>
            </vx-card>
          </vs-col>
          <vs-col vs-type="flex" vs-lg="6" vs-xs="12">
            <vx-card class="plan-view basic-plan">
              <div class="plan-title">ベーシックプラン</div>
              <vs-divider :color="AISEA_COLOR.BLUE"></vs-divider>
              <div class="price-area flex justify-center items-center">
                <div>
                  <div class="pb-2 flex items-baseline justify-center">
                    <span class="price-text" style="font-size: 16px"
                      >1隻あたり</span
                    >
                    <span class="price-text" style="font-size: 28px"
                      >¥9,800</span
                    >
                    <span
                      :style="{ color: AISEA_COLOR.BLACK }"
                      style="font-size: 18px"
                      >/月</span
                    >
                  </div>
                  <div class="flex justify-center">
                    <span class="basic-price-text"
                      >基本利用料：￥25,000/社</span
                    >
                  </div>
                  <div style="position: relative">
                    <div class="campaign-area">
                      永年無料キャンペーン実施中！
                    </div>
                  </div>
                </div>
              </div>
              <div class="plan-explain-alea">
                <vs-divider :color="AISEA_COLOR.SLIGHTLY_GRAY"></vs-divider>
                <div class="flex justify-between px-2 items-center">
                  <span class="title">機能</span>
                  <span class="value">無制限</span>
                </div>
                <vs-divider :color="AISEA_COLOR.SLIGHTLY_GRAY"></vs-divider>
                <div class="flex justify-between px-2 items-center">
                  <span class="title">船舶数</span>
                  <span class="value">無制限</span>
                </div>
                <vs-divider :color="AISEA_COLOR.SLIGHTLY_GRAY"></vs-divider>
                <div class="flex justify-between px-2 items-center">
                  <span class="title">船員・陸上管理者数</span>
                  <span class="value">無制限</span>
                </div>
                <vs-divider :color="AISEA_COLOR.SLIGHTLY_GRAY"></vs-divider>
                <div class="flex justify-between px-2 items-center">
                  <span class="title">利用可能期間</span>
                  <span class="value">無制限</span>
                </div>
                <vs-divider :color="AISEA_COLOR.SLIGHTLY_GRAY"></vs-divider>
                <div class="mb-4 h-24">
                  <span class="plan-explain-text"
                    >トライアル終了後に本格運用するための基本的なプランです。</span
                  >
                </div>

                <div class="update-plan-button" @click="upgradePlan">
                  利用開始
                </div>
              </div>
            </vx-card>
          </vs-col>
        </vs-row>
      </div>
    </vs-prompt>

    <!-- 利用プラン変更確認ダイアログ -->
    <confirm-plan-dialog ref="ConfirmPlanDialog"></confirm-plan-dialog>
  </div>
</template>

<script>
import { DeviceInfoMixin, ColorMixin } from "@/mixins";
import ConfirmPlanDialog from "./ConfirmPlanDialog";

export default {
  mixins: [DeviceInfoMixin, ColorMixin],
  components: {
    ConfirmPlanDialog
  },
  data () {
    return {
      showPlanDialog: false,
    };
  },
  watch: {
  },
  computed: {
  },
  methods: {
    upgradePlan () {
      this.showPlanDialog = false;
      this.$refs.ConfirmPlanDialog.showConfirmDialog = true;
    },
  }
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";

.user-plan-dialog-area {
  background-color: #ffffff;
  font-size: 16px;

  .dialog-header {
    padding: 8px 0px;
    .dialog-title {
      color: $aisea-blue;
      font-size: 24px !important;
      font-weight: 600;
      margin-bottom: 4px;
    }
  }

  .vx-card__body {
    padding: 0px !important;
  }

  .vs-divider {
    margin: 12px 0px !important;
  }

  .plan-view {
    width: 100%;
    border-radius: 6px;
    margin: 12px;

    .plan-title {
      padding-top: 12px;
      font-weight: 600;
      text-align: center;
      color: $aisea-gray;
    }

    .price-area {
      height: 100px;
      .price-text {
        color: $aisea-blue;
        font-weight: 600;
      }

      .basic-price-text {
        color: $aisea-gray;
        font-size: 14px;
        text-decoration: line-through;
        text-align: center;
      }

      .campaign-area {
        background-color: #69d813;
        margin: 4px;
        padding: 2px 6px;
        color: $aisea-pure-white;
        border-radius: 12px;
        font-size: 14px;
        font-weight: 600;
      }

      .campaign-area:after {
        content: "";
        position: absolute;
        right: 0;
        top: -10px;
        left: 0;
        width: 0px;
        height: 0px;
        margin: auto;
        border-style: solid;
        border-color: transparent transparent #69d813 transparent;
        border-width: 5px 5px 5px 5px;
      }
    }

    .plan-explain-alea {
      padding: 24px;
      padding-top: 0px;

      .title {
        font-size: 14px;
        color: $aisea-dark-gray;
      }
      .value {
        color: $aisea-blue;
        font-weight: 600;
        font-size: 18px;
      }
      .plan-explain-text {
        font-size: 16px;
        color: $aisea-gray-black;
      }
    }

    .update-plan-button {
      display: flex;
      height: 42px;
      border-radius: 6px;
      font-size: 14px;
      color: $aisea-white;
      justify-content: center;
      align-items: center;
      background-color: $aisea-blue;
      cursor: pointer;
    }

    .selected-plan {
      background-color: $aisea-mouse-gray;
      cursor: default;
    }
  }

  .free-plan {
    width: 100%;
  }

  .basic-plan {
    background-color: #039be50d;
    width: 100%;
  }
}

.user-plan-prompt {
  .vs-dialog {
    max-width: 750px !important;
    margin: 10px;
    min-height: calc(100vh - 40px - 40px) !important;

    .vs-dialog-text {
      padding: 4px !important;
    }

    .vs-dialog-header {
      display: none;
      background-color: #ffffff;
    }

    .vs-dialog-cancel {
      background-color: rgba(244, 244, 244, 0) !important;
      transform: none !important;
      box-shadow: none !important;
    }
  }
}

</style>
